<template>
  <div
    class="answer--file"
    @contextmenu.prevent.stop="onContextmenu">
    <div class="file-list">
      <ul>
        <template v-for="(file, index) in prependFiles">
          <li @click.stop="onPrependView(index)">
            <answer-file
              :type="type"
              :file="file"/>
          </li>
          <li v-if="prependFiles.length === index+1"
              class="file-separate-line"></li>
        </template>
        <draggable v-model="draggableFiles"
                   :options="{disabled:false}"
                   @update="onSortUpdate">
          <template v-for="(file, index) in files">
            <li @click.stop="onCheck(index)"
                @contextmenu.prevent.stop="(event)=>{onContextmenu(event, index)}">
              <answer-file
                :type="type"
                :file="file"
                :index="index"
                :checked="checkedFiles.includes(file)"/>
            </li>
          </template>
        </draggable>
        <li>
          <answer-file-upload
            :question="question"
            :type="type"
            :uploadData="uploadData"
            :questionIndex="questionIndex"
            :datetime="datetime"/>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import QuestionReview from '../../question-review.js'
import AnswerFileFullScreen from '../../components/AnswerFileFullScreen'
import OrderRecordAudioViewer from '../../components/OrderRecordAudioViewer'
import ContextMenu from '../../components/ContextMenu'
import AnswerFile from '@/views/question-review/packages/AnswerFileList/AnswerFile'
import AnswerFileUpload from '@/views/question-review/packages/AnswerFileList/AnswerFileUpload'
import {
  createFileSrcSnapshot,
  isAnnotationFileSrcOnlyChange,
} from './annotationFileChange'

export default {
  components: {AnswerFileUpload, AnswerFile, draggable},
  inject: ['page'],
  mixins: [],
  props: {
    prependFiles: Array,
    files: Array,
    questionIndex: Number,
    question: Object,
    type: String,
    uploadData: Object,
    contextMenuContainer: Element,
    getLableData: Function,
    datetime: String,
  },
  data () {
    return {
      draggableFiles: this.files,
      checkMode: false,
      uniqueId: _.uniqueId(),
      checkedFiles: [],
      fileSrcSnapshot: createFileSrcSnapshot(this.files),
    }
  },
  computed: {
    isMacOS () {
      return navigator.platform.indexOf('Mac') === 0
    },
    controlKeyCode () {
      return this.isMacOS ? 91 : 17
    },
  },
  watch: {
    'files': {
      handler: function (val) {
        const isAnnotationChange = isAnnotationFileSrcOnlyChange(val, this.fileSrcSnapshot)
        this.draggableFiles = val
        this.fileSrcSnapshot = createFileSrcSnapshot(val)
        if (isAnnotationChange) return
        this.$emit('change', val)
      },
      deep: true,
    },
  },
  beforeCreate () {},
  created () {
    this.addEventListener()
    this.$nextTick(() => {})
  },
  mounted () {
    ContextMenu({
      uploadData: this.uploadData
    })
  },
  destroyed () {
    this.removeEventListener()
  },
  methods: {
    ...Vuex.mapActions(['uploadOrderReviewFile']),
    onSortUpdate (sort) {
      QuestionReview().changeEvidenceIndex(this.question.id, sort.oldIndex, sort.newIndex)
      this.$message.warning('已更改证据列表顺序')
    },
    onContextmenu ({clientX, clientY}, index) {
      ContextMenu({readOnly: false})
      // 匹配右击菜单作用域
      ContextMenu().scope !== this.uniqueId && ContextMenu().empty()
      // 判断右击是否在项目上
      if (Number.isInteger(index) && index >= 0) {
        let file = this.files[index]
        if (!this.checkedFiles.includes(file)) {
          ContextMenu().empty()
          ContextMenu().checked(file)
          this.checkedFiles = ContextMenu().checkedFiles
        }
      } else {
        ContextMenu().empty()
      }
      ContextMenu().setScope(this.uniqueId)
      ContextMenu().setType(this.type)
      ContextMenu().setFiles(this.files)
      ContextMenu().show(clientX, clientY)

      // TODO: 为了切换审核历史也能复制 这里暂时存到本地
      if (localStorage.getItem('copyForReloadReviewData') && localStorage.getItem('copyForReloadReviewDataType') && localStorage.getItem('copyForReloadReviewDataType') === this.type) {
        const list = JSON.parse(localStorage.getItem('copyForReloadReviewData'))
        ContextMenu().setStageFiles(list)
        // 当时复制的那个类型
        ContextMenu().setCopyType(localStorage.getItem('copyForReloadReviewDataType'))
      }

      // TODO: 为了二维码的复制 这里暂时存到本地
      if (this.type === 'qrcode') {
        if (localStorage.getItem('copyForQrcode')) {
          const list = JSON.parse(localStorage.getItem('copyForQrcode'))
          ContextMenu().setStageFiles(list)
          ContextMenu().setCopyType(this.type)
        }
      }
    },
    onCheck (index) {
      ContextMenu().hide()
      if (this.checkMode) {
        ContextMenu().checked(this.files[index])
      } else {
        this.onView(index)
      }
    },
    onView (index) {
      if (this.type === 'record') {
        OrderRecordAudioViewer.open({
          question: this.question,
          questionIndex: this.questionIndex,
          files: this.files,
          viewIndex: index,
          toolbar: {delete: true, label: true},
          getLableData: this.getLableData,
          orderDetail: this.page.orderDetail,
        })
        return
      }
      AnswerFileFullScreen({
        question: this.question,
        questionIndex: this.questionIndex,
        files: this.files,
        viewIndex: index,
        type: this.type,
        toolbar: {delete: true, label: true},
        getLableData: this.getLableData,
        orderDetail: this.page.orderDetail,
        onDrawSavedFunc: ({message}) => {
          this.markQuestionNotPassedByDraw(message)
        },
      })
    },
    onPrependView (index) {
      if (this.type === 'record') {
        OrderRecordAudioViewer.open({
          question: this.question,
          questionIndex: this.questionIndex,
          files: this.prependFiles,
          viewIndex: index,
          orderDetail: this.page.orderDetail,
        })
        return
      }
      AnswerFileFullScreen({
        question: this.question,
        questionIndex: this.questionIndex,
        files: this.prependFiles,
        viewIndex: index,
        type: this.type,
        onDrawSavedFunc: ({message}) => {
          this.markQuestionNotPassedByDraw(message)
        },
      })
    },
    markQuestionNotPassedByDraw (message) {
      if (!this.question || !this.question.id) return
      this.$emit('draw-saved', {
        question: this.question,
        message,
      })
    },
    addEventListener () {
      document.addEventListener('keydown', this.keydown)
      document.addEventListener('keyup', this.keyup)
      document.addEventListener('click', this.clickDoc)
      document.addEventListener('visibilitychange', this.visibilityChange)
    },
    removeEventListener () {
      document.removeEventListener('keydown', this.keydown)
      document.removeEventListener('keyup', this.keyup)
      document.removeEventListener('click', this.clickDoc)
      document.removeEventListener('visibilitychange', this.visibilityChange)
    },
    keyup (event) {
      let control = this.controlKeyCode
      switch (event.keyCode || event.which || event.charCode) {
        // Control
        case control:
          this.checkMode = false
          break
      }
    },
    keydown (event) {
      let control = this.controlKeyCode
      switch (event.keyCode || event.which || event.charCode) {
        // Control
        case control:
          this.checkMode = true
          break
      }
    },
    clickDoc () {
      ContextMenu().hide()
    },
    visibilityChange () {
      // TODO 会触发多次，事件需要外部组件触发
      // document.visibilityState hidden visible
      this.checkMode = false
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/packages/AnswerFileList/ChangeFileList.vue